import * as React from 'react';

import { AuthorCard } from '../AuthorCard/AuthorCard';
import { routes } from '../../config/routes';

import * as cs from './HeroAuthors.module.css';

interface Props {
  entries: Queries.BlogPostPageEntryFragment['authors'];
}

export const HeroAuthors = ({ entries }: Props) => (
  <ul className={cs.root}>
    {entries.map((author) => (
      <li key={author.slug}>
        <AuthorCard
          about={author.about}
          name={author.name}
          link={routes.author(author.slug)}
          avatar={author.avatar?.childImageSharp?.gatsbyImageData}
          withPlaceholder
        />
      </li>
    ))}
  </ul>
);
